import React, { Component } from "react";
import {
  Modal,
  ModalBody,
  Button,
  ModalHeader,
  Label,
  ModalFooter,
  Input,
  Alert,
  Col,
  Row,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions/index";
import Loading from "../../../hoc/Loading/Loading";
import { FaArrowRight } from "react-icons/fa6";
import Select, { Option, defaultMenuRenderer } from "react-select";
import { BiTrashAlt, BiX } from "react-icons/bi";
import {
  isUrlValid,
  uploadPreview,
  wikimediaAuth,
  triviaCategoryAPI,
  triviaListCategories,
} from "../../../utils/constants";
import { withRouter } from "react-router-dom";
import { toastContainer } from "../../../utils/toast";
// FaUber
import { FaUber } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { minPlanLimitCheck, REWARD_ADMIN_EMAIL_TYPES } from "../data";
import Toggle from "react-toggle";

class CreateTriviaPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allTrivvyList: [],
      allTrivvyListAllData: [],
      trivvyArticles: [],
      rewardDate: null,
      selectedRounds: 0,
      rewardTypes: [],
      customRewardTitle: "",
      customRewardDescription: "",
      rewardTypesMain: [],
      selectedTrivvyId: null,
      trivvyRoundsSelectArr: [],
      allDraftTrivvys: [],
      selectedReward: null,
      roundsOfTrivia: [
        { label: "1 round of trivia", value: 1 },
        { label: "2 rounds of trivia", value: 2 },
        { label: "3 rounds of trivia", value: 3 },
        { label: "4 rounds of trivia", value: 4 },
        { label: "5 rounds of trivia", value: 5 },
      ],
      triviaGenerateLoading: false,
      rewardName: "",
      generate_success_id: null,
      uploadUrl: "",
      adminEmailTriggerType: 1,
      endDateAdd: false,
      selectWinnersManually: false,
    };
    this.timer = null;
  }

  //   const customSingleValue = ({ options }) => (
  //     <div className="input-select">
  //         <div className="input-select__single-value">
  //             { options.icon && <span className="input-select__icon">{ options.icon }</span> }
  //             <span>{ options.label }</span>
  //         </div>
  //     </div>
  // );

  // componentDidUpdate(prevProps,prevState){
  // 	if(this.props.members.length!=prevProps.members.length){
  // 		this.setState({currentMembers:this.props.members.map(e=>e.o_id)})
  // 	}
  // }

  componentDidMount() {
    // this.getAllTriviaList();
    this.getDraftTrivvys();
    this.getCustomRewards();
  }

  getCustomRewards = () => {
    axios
      .get(url.getCustomRewards)
      .then(({ data }) => {
        const rewardTypes = data.data.map((x) => ({
          value: x._id,
          label: x.title,
          description: x.description,
          orgId: x.organizationId,
        }));
        rewardTypes.push({
          label: "Other",
          value: "OTHER",
        });
        this.setState({ rewardTypes: rewardTypes, rewardTypesMain: data.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  selectArticle = (url) => {
    this.setState({ uploadUrl: url });
  };

  showArticleList = () => {
    let { trivvyArticles, uploadUrl } = this.state;
    console.log("trivvyArticles --- ", trivvyArticles.length);

    if (trivvyArticles) {
      return trivvyArticles.map((e, index) => {
        let title = `${e.title.slice(0, 60)}${
          e.title.length > 60 ? " ..." : ""
        }`;
        return (
          <div
            className={`width-line ${
              uploadUrl && uploadUrl == e.link ? "highlight-tile" : ""
            }`}
            key={index + e.link}
          >
            <span onClick={() => this.selectArticle(e.link)}>
              <div className="card-gradient" />
              <img
                className="card-rss-img"
                src={e.image}
                // onclick="toggleSelection(this)"
              />
              <p className="line-up">{title}</p>
              {/* <span class="decrip">{e.description}</span> */}
            </span>
            <a href={e.link} target="_blank">
              View
            </a>
          </div>
        );
      });
    }
  };

  getAllArticlesList = async () => {
    let response = await fetch(triviaCategoryAPI(), {
      headers: {
        Authorization: wikimediaAuth,
        "Api-User-Agent": "Trivvy(acqajar@gmail.com)",
      },
    });
    response.json().then((data) => {
      console.log("data --- ", data);
      let arrayObj = [];
      if (data.mostread) {
        arrayObj = data.mostread.articles;

        arrayObj.map((e) => {
          e.link = e.content_urls.mobile.page;
          // e.title = e.normalizedtitle
          e.title = e.extract;
          e.description = e.extract_html;
          e.author = "Wikipedia";
          e.date = e.timestamp;
          e.image =
            e.originalimage &&
            e.originalimage.source &&
            e.originalimage.source.length > 0
              ? e.originalimage.source
              : null;
          return e;
        });

        arrayObj = arrayObj.filter((e) => e.image != null);

        console.log("arrayObj --- ", arrayObj);
      } else {
        arrayObj = data.onthisday;
      }
      console.log("arrayObj -- ", arrayObj);
      this.setState({ trivvyArticles: arrayObj });
    });
  };

  // getAllTriviaList = () => {allDraftTrivvys
  //   axios
  //     .get(url.getRewardsTrivvyList)
  //     .then(({ data }) => {
  //       this.setState({ allTrivvyList: data.data });
  //       this.getAllArticlesList()
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // getTriviaCategory = async (itm, cb) => {
  //   // let category = itm.name;

  //   let response = await fetch(triviaCategoryAPI(), {
  //     headers: {
  //       Authorization: wikimediaAuth,
  //       "Api-User-Agent": "Trivvy(acqajar@gmail.com)",
  //     },
  //   });
  //   response.json().then((data) => {
  //     console.log("data --- ", data);
  //     let arrayObj = [];
  //     if (data.mostread) {
  //       arrayObj = data.mostread.articles;

  //       arrayObj.map((e) => {
  //         e.link = e.content_urls.mobile.page;
  //         // e.title = e.normalizedtitle
  //         e.title = e.extract;
  //         e.description = e.extract_html;
  //         e.author = "Wikipedia";
  //         e.date = e.timestamp;
  //         e.image =
  //           e.originalimage &&
  //           e.originalimage.source &&
  //           e.originalimage.source.length > 0
  //             ? e.originalimage.source
  //             : null;
  //         return e;
  //       });

  //       arrayObj = arrayObj.filter((e) => e.image != null);

  //       console.log("arrayObj --- ", arrayObj);
  //     } else {
  //       arrayObj = data.onthisday;
  //     }
  //     console.log("arrayObj -- ", arrayObj);
  //     this.setState({ trivvyArticles: arrayObj });
  //   });
  // };

  setLoading = (val) => {
    this.setState({ triviaGenerateLoading: val });
  };

  createReward = () => {
    let {
      rewardDate,
      rewardName,
      trivvyRoundsSelectArr,
      selectedReward,
      selectedRounds,
      rewardTypes,
      allTrivvyListAllData,
      customRewardTitle,
      customRewardDescription,
      adminEmailTriggerType,
      selectWinnersManually,
    } = this.state;
    this.setLoading(true);

    const linkedTriviasFinal = trivvyRoundsSelectArr
      .map((itm) => {
        const mainTriviaObject = allTrivvyListAllData.find(
          (x) => x._id == itm.trivvyId
        );

        if (mainTriviaObject) {
          return {
            triviaId: mainTriviaObject._id,
            triviaName: mainTriviaObject.name,
            triviaCreatedBy: mainTriviaObject.createdBy,
            triviaSourceLink: mainTriviaObject.uploadUrl,
            linkedOn: new Date(),
          };
        } else {
          return null;
        }
      })
      .filter((x) => x != null);

    const payload = {
      rewardName: rewardName,
      rewardDate,
      rewardText: selectedReward.value == "OTHER" ? null : selectedReward.label,
      linkedTrivias: linkedTriviasFinal,
      totalRounds: selectedRounds,
      customRewardId: selectedReward.value,
      customRewardTitle,
      customRewardDescription,
      rewardDesc: selectedReward.description,
      adminEmailTriggerType,
      selectWinnersManually,
    };

    axios
      .post(url.generateReward, payload)
      .then(({ data }) => {
        toastContainer("Reward generated successfully", "success");
        this.setLoading(false);
        if (this.props.addDataInRow) {
          this.props.addDataInRow(data.data);
        }
        if (this.props.onClose) {
          this.props.onClose();
        }
      })
      .catch((error) => {
        this.setLoading(false);
        let message = "Error occured while sending message";
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          message = error.response.data.errors.message;
        }
        toastContainer(message, "error");
      });
  };

  getDraftTrivvys = () => {
    axios
      .get(url.getDraftsTrivvyList)
      .then(({ data }) => {
        const filteredMCQTypeTrivvys = [];

        for (const itm of data.data) {
          let toPush = false;

          console.log(itm.questions);
          if (
            itm.questions &&
            Array.isArray(itm.questions) &&
            itm.questions.length
          ) {
            for (const question of itm.questions) {
              if (question.question_type == "MCQ") {
                toPush = true;
              }
            }
          }

          if (toPush) {
            filteredMCQTypeTrivvys.push(itm);
          }
        }

        if (
          this.props.preSelectedTriviaIds &&
          this.props.preSelectedTriviaIds.length
        ) {
          console.log("d1-----",this.props.preSelectedTriviaIds,filteredMCQTypeTrivvys.map(c => c._id))
          const trivvys = filteredMCQTypeTrivvys.filter((x) =>
            this.props.preSelectedTriviaIds.includes(x._id)
          );

          const preselected = trivvys.map((x) => ({
            trivvyId: x._id,
            trivvyEndDate: x.trivvyEndDate,
          }));

          console.log({preselected})

          this.setState({
            trivvyRoundsSelectArr: preselected,
            selectedRounds:preselected.length
          });
        }
        this.setState({
          allTrivvyListAllData: filteredMCQTypeTrivvys,
          allDraftTrivvys: filteredMCQTypeTrivvys.map((x) => ({
            label: x.name,
            value: x._id,
            trivvyEndDate: x.trivvyEndDate,
          })),
        });
        // this.getAllArticlesList()
      })
      .catch((err) => {
        console.log(err);
      });
  };

  addTrivvy = (trivvyId, i) => {
    const arr = [...this.state.trivvyRoundsSelectArr];

    const objectTrivvy = this.state.allDraftTrivvys.find(
      (x) => x.value == trivvyId
    );

    arr[i] = {
      trivvyId,
      trivvyEndDate:objectTrivvy ?  objectTrivvy.trivvyEndDate:null,
    };

    this.setState({
      trivvyRoundsSelectArr: [...arr],
    });
  };

  handleDateChange = (value) => {
    if (value) {
      const date = moment(value)
        .endOf("day")
        .local();
      this.setState({ rewardDate: date });
    } else {
      this.setState({ rewardDate: null });
    }
  };

  trivvyEndDateCheck = (endDate) => {
    const { rewardDate } = this.state;

    if (
      moment(rewardDate)
        .endOf("day")
        .toDate() <
      moment(endDate)
        .endOf("day")
        .toDate()
    ) {
      return false;
    } else {
      return true;
    }
  };

  buttonDisabled = () => {
    let {
      rewardDate,
      trivvyRoundsSelectArr,
      selectedReward,
      selectedRounds,
      rewardTypes,
      rewardName,
      customRewardTitle,
    } = this.state;

    console.log("vvvvv", trivvyRoundsSelectArr.length, selectedRounds);

    if (rewardName && rewardDate && selectedReward && selectedRounds) {
      const validTrivvyRoundsSelectArrLen = trivvyRoundsSelectArr.filter(
        (x) =>
          x.trivvyId &&
          x.trivvyId != null &&
          x.trivvyEndDate != null &&
          this.trivvyEndDateCheck(x.trivvyEndDate)
      ).length;

      console.log(
        "validTrivvyRoundsSelectArrLen",
        validTrivvyRoundsSelectArrLen
      );

      const customFieldCheck =
        selectedReward.value == "OTHER"
          ? customRewardTitle
            ? true
            : false
          : true;
      if (validTrivvyRoundsSelectArrLen == selectedRounds && customFieldCheck) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  handleRewardDelete = (id) => {
    const data = [...this.state.rewardTypes];

    const index = data.findIndex((c) => c.value == id);

    data.splice(index, 1);

    console.log(data);

    this.setState({ rewardTypes: data });

    if (this.state.selectedReward && id == this.state.selectedReward.value) {
      this.setState({ selectedReward: null });
    }

    axios
      .delete(url.deleteRewardTemplate(id))
      .then((res) => {
        toastContainer("Custom reward removed", "success");
      })
      .catch((err) => {
        toastContainer("Error while removing custom reward", "error");
      });
  };

  editTrivvyEndDate = (index, endDate, trivvyId) => {
    const arr = [...this.state.trivvyRoundsSelectArr];

    const draft = [...this.state.allDraftTrivvys];
    const objectTrivvyIndex = draft.findIndex((x) => x.value == trivvyId);
    if (objectTrivvyIndex >= 0) {
      draft[objectTrivvyIndex] = {
        ...draft[objectTrivvyIndex],
        trivvyEndDate: endDate,
      };

      this.setState({
        allDraftTrivvys: draft,
      });

      if (this.trivvyEndDateCheck(endDate)) {
        axios
          .put(url.editTrivia(draft[objectTrivvyIndex].value), {
            updateData: {
              trivvyEndDate: endDate,
            },
          })
          .then((data) => {
            console.log(data.data);
            toastContainer("End date changed successfully", "success");
          })
          .catch((err) => {
            toastContainer("Error while editing End Date", "error");
          });
      }
    }
    arr[index] = {
      ...arr[index],
      trivvyEndDate: endDate,
    };

    this.setState({
      trivvyRoundsSelectArr: [...arr],
    });
  };

  render() {
    let {
      loading,
      triviaGenerateLoading,
      roundsOfTrivia,
      selectedRounds,
      rewardTypes,
      selectedReward,
      allDraftTrivvys,
      trivvyRoundsSelectArr,
      rewardDate,
      rewardName,
      customRewardDescription,
      customRewardTitle,
      selectWinnersManually,
    } = this.state;

    const { open, onClose } = this.props;

    const trivvyPlanType = this.props.user.organizationId.trivvyPlanType;

    const CustomOption = ({ children, ...props }) => (
      <Option {...props} onSelect={() => {}}>
        {console.log("nnnnnn", children, props)}
        <div className="d-flex align-items-center">
          <span
            style={{
              cursor: "pointer",
              width: "95%",
            }}
            onClick={() => {
              props.onSelect();
              this.setState({
                selectedReward: props.option,
              });
            }}
          >
            {children}
          </span>{" "}
          {props.option.orgId && (
            <BiTrashAlt
              onClick={(e) => {
                e.stopPropagation();
                this.handleRewardDelete(props.option.value);
              }}
            />
          )}
        </div>
      </Option>
    );

    console.log(
      trivvyRoundsSelectArr,
      "---- selectedRounds --- ",
      selectedRounds
    );

    return (
      <div>
        <Modal
          isOpen={open}
          className="create-trivia-modal-component trivia-reward-modal-component"
        >
          <ModalHeader
            className="trivia_modal_header_bg"
            close={
              <BiX
                className="cursor-pointer"
                color="gray"
                size={30}
                onClick={() => onClose()}
              />
            }
          >
            Set Reward Guidelines
          </ModalHeader>
          <ModalBody
            className={`px-5 pt-0 pb-2 ${
              loading ? "wrapped-component-on-loading" : ""
            }`}
          >
            <div className="my-3">
            Create a reward for users based on a single or multiple unpublished trivvys. Or, want to create a Trivvy, <span onClick={()=>{
              if(this.props.openCreateTrivvy){
                this.props.openCreateTrivvy()
              }
             
            }} className="text-info cursor-pointer">click here</span>.
            </div>
            <div className="my-3">
              <Label>Reward Name</Label>
              <Input
                className="w-100"
                value={rewardName}
                onChange={(e) => this.setState({ rewardName: e.target.value })}
                placeholder="Enter reward name"
              />
            </div>
            <div className="my-3">
              <Label>
                Select Reward or{" "}
                <Button
                  onClick={() => {
                    this.setState({
                      selectedReward: { label: "Other", value: "OTHER" },
                    });
                  }}
                  className="trivia-action-button-main"
                  size="sm"
                >
                  Custom reward
                </Button>
              </Label>
              <Select
                value={selectedReward ? selectedReward : null}
                //  onChange={e => {
                //    this.setState({selectedReward:e})
                //  }}
                options={rewardTypes}
                optionComponent={(props) => <CustomOption {...props} />}
                placeholder="Select reward."
              ></Select>
            </div>

            {selectedReward && selectedReward.value === "OTHER" ? (
              <div className="my-3 p-3 border createCustomReward_css">
                <div className="mb-2">
                  <h6 style={{ fontWeight: "600" }}>Create custom reward</h6>
                </div>

                <div className="my-3">
                  <Label>Custom Reward</Label>
                  <Input
                    className="w-100"
                    value={customRewardTitle}
                    onChange={(e) =>
                      this.setState({ customRewardTitle: e.target.value })
                    }
                    placeholder="Enter custom reward eg: Uber voucher"
                  />
                </div>

                <div className="my-3">
                  <Label>Custom Reward Description</Label>
                  <Input
                    type="textarea"
                    className="w-100"
                    value={customRewardDescription}
                    onChange={(e) =>
                      this.setState({ customRewardDescription: e.target.value })
                    }
                    placeholder="Enter custom reward eg: Uber voucher"
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="my-3">
              <Label>Select Reward end date </Label>

              <DatePicker
                id="actionDueDate"
                placeholderText="Enter date: MM/DD/YYYY"
                className="form-control filter-action-date-input"
                selected={rewardDate}
                onChange={this.handleDateChange}
                showYearDropdown
                minDate={moment().toDate()}
              />
            </div>

            <div className="my-3">
              <Label>
                {" "}
                Reward receipient should be determined after how many rounds of
                trivia?{" "}
              </Label>
              <Select
                value={selectedRounds}
                onChange={(e) => {
                  if (e && e.value) {
                    this.setState({
                      selectedRounds: e.value,
                    });
                  } else {
                    this.setState({
                      selectedRounds: null,
                    });
                  }

                  if(!trivvyRoundsSelectArr.length){
                    const objects_arr = [];

                    objects_arr.push({
                      trivvyId: "",
                    });
  
                    this.setState({ trivvyRoundsSelectArr: objects_arr });
                  }

                 
                }}
                options={roundsOfTrivia}
                placeholder="Rounds of trivia"
              />
            </div>

            {(selectedRounds || trivvyRoundsSelectArr.length) ? (
              <div>
                <Label className="my-1">Select {selectedRounds} Trivvys:</Label>
                {trivvyRoundsSelectArr.map((item, index) => {
                  const validOptions = allDraftTrivvys.map((x) => ({
                    ...x,
                    disabled:
                      trivvyRoundsSelectArr.findIndex(
                        (y) => y.trivvyId == x.value
                      ) >= 0,
                  }));
                  return (
                    <div className="my-2">
                      <Row>
                        <Col sm={6}>
                          <Select
                            value={item.trivvyId}
                            options={validOptions}
                            onChange={(e) => {
                              if(e){
                                this.addTrivvy(e.value, index);
                              }else{
                                this.addTrivvy(null, index);
                              }
                            }}
                            placeholder="Select Trivia"
                          />
                        </Col>
                        <Col sm={5}>
                          {item.trivvyEndDate ? (
                            <div>
                              {rewardDate &&
                              moment(rewardDate)
                                .endOf("day")
                                .toDate() <
                                moment(item.trivvyEndDate)
                                  .endOf("day")
                                  .toDate() ? (
                                <div>
                                  <div className="text-danger">
                                    <DatePicker
                                      minDate={moment().toDate()}
                                      id="actionDueDate"
                                      placeholderText="Enter date: MM/DD/YYYY"
                                      className="form-control filter-action-date-input"
                                      selected={
                                        typeof item.trivvyEndDate == "string"
                                          ? moment(item.trivvyEndDate).local()
                                          : item.trivvyEndDate
                                      }
                                      onChange={(v) => {
                                        const date = moment(v).local();

                                        this.editTrivvyEndDate(
                                          index,
                                          date,
                                          item.trivvyId
                                        );
                                      }}
                                      showYearDropdown
                                    />
                                    <div>
                                      <small>
                                        The Trivvy End Date is beyond the reward
                                        date please Edit Trivvy end date or
                                        choose other reward date
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="text-success">
                                  End Date :{" "}
                                  {moment(item.trivvyEndDate).format(
                                    "MM/DD/YYYY"
                                  )}
                                </div>
                              )}
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                              }}
                            >
                              {this.state.endDateAdd ? (
                                <DatePicker
                                  id="actionDueDate"
                                  placeholderText="Enter date: MM/DD/YYYY"
                                  className="form-control filter-action-date-input"
                                  selected={
                                    typeof item.trivvyEndDate == "string"
                                      ? moment(item.trivvyEndDate).local()
                                      : item.trivvyEndDate
                                  }
                                  onChange={(v) => {
                                    const date = moment(v).local();

                                    this.editTrivvyEndDate(
                                      index,
                                      date,
                                      item.trivvyId
                                    );
                                  }}
                                  showYearDropdown
                                />
                              ) : (
                                <span
                                  className="text-info cursor-pointer"
                                  onClick={() =>
                                    this.setState({ endDateAdd: true })
                                  }
                                >
                                  Add End Date (required*)
                                </span>
                              )}
                            </div>
                          )}
                        </Col>
                        <Col sm={1}>
                          <BiTrashAlt
                            onClick={() => {
                              const data = [...trivvyRoundsSelectArr];
                              data.splice(index, 1);
                              this.setState({ trivvyRoundsSelectArr: data });
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  );
                })}

                <Button
                  disabled={trivvyRoundsSelectArr.length >= selectedRounds}
                  onClick={() => {
                    const objects_arr = [...trivvyRoundsSelectArr];

                    objects_arr.push({
                      trivvyId: "",
                    });

                    this.setState({ trivvyRoundsSelectArr: objects_arr });
                  }}
                  className="trivia-action-button-main"
                >
                  Add New +
                </Button>
              </div>
            ) : (
              ""
            )}

            <div className="my-3">
              <Label>Select when to notify you</Label>
              <Select
                value={this.state.adminEmailTriggerType}
                options={REWARD_ADMIN_EMAIL_TYPES}
                onChange={(v) => {
                  if(v){
                    this.setState({
                      adminEmailTriggerType: v.value,
                    });
                  }else{
                    this.setState({
                      adminEmailTriggerType: 1,
                    });
                  }
                 
                }}
                placeholder="Select notification trigger type ..."
              />
            </div>

            {/* <div
              className="my-3 d-flex align-items-center"
              style={{
                opacity: minPlanLimitCheck(trivvyPlanType, "003") ? 1 : 0.4,
              }}
            >
              <span className="mr-2">Select Winners Manually</span>

              <Toggle
                checked={selectWinnersManually}
                onChange={(e) => {
                  this.setState({
                    selectWinnersManually: e.target.checked,
                  });
                }}
                disabled={!minPlanLimitCheck(trivvyPlanType, "003")}
                icons={false}
              />
            </div> */}
          </ModalBody>

          <ModalFooter>
            {!triviaGenerateLoading ? (
              <Button
                color="success"
                className="mr-4 btn-success"
                onClick={() => {
                  this.createReward();
                }}
                disabled={this.buttonDisabled()}
              >
                Generate <FaArrowRight className="ml-2" />{" "}
              </Button>
            ) : (
              <span>Generating...</span>
            )}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    storyMetricsChange: (data) =>
      dispatch(actionCreators.storyMetricsChange(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateTriviaPopup)
);
